import { useSignedStorageUrl } from "@/hooks/useSignedStorageUrl";

interface SignedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string | null | undefined;
}

/**
 * Renders an image from a Supabase Storage public URL, automatically
 * requesting a signed URL when the bucket is private. Non-Storage URLs
 * pass through unchanged.
 */
export function SignedImage({ src, ...props }: SignedImageProps) {
  const { signedUrl } = useSignedStorageUrl(src);
  if (!signedUrl) return null;
  return <img src={signedUrl} {...props} />;
}
